module.exports = __webpack_public_path__ + "static/img/syfl-1.71e300c3.jpg";